import { FinishController } from './finish.controller';
import template from './finish.html';
import '../../common/ui/feedback/feedback';

export const finishComponent = {
  name: 'finishComponent',
  restrict: 'E',
  template,
  controller: FinishController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/finish/finish.component.js